module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/message-alert/message-alert-style4/message-alert-style4.component.scss
// module id = ./src/app/features/message-alert/message-alert-style4/message-alert-style4.component.scss
// module chunks = main